import React, { useState } from "react";
import NavbarS4 from "../../components/NavbarS4/NavbarS4";
import Logo from '../../images/logo2.png'
import Footer from "../../components/footer/Footer";
import PageTitle from "../../components/pagetitle/PageTitle";
import ScrollTextAnimation from "../../components/ScrollTextAnimation/ScrollTextAnimation";
import Scrollbar from '../../components/scrollbar/scrollbar';
import SEO from "../../components/Seo";
import { jobs } from "../../api/jobsData";
import { Link } from "react-router-dom";
import ApplyForm from "../../components/applyform/ApplyForm";

// import "./career.scss";



export default function Career() {
    const [openForm, setOpenForm] = useState(false);

    return (
        <>
            <SEO
                title="Careers at LuxRock Realty | Join Our Real Estate Team"
                description="Explore career opportunities at LuxRock Realty and build your future in the real estate industry. Join our growing team of property experts and consultants."
                keywords="LuxRock Realty careers, real estate jobs, property consultant jobs, real estate career opportunities"
            />
            <NavbarS4 hclass={'wpo-site-header wpo-header-style-s11'} Logo={Logo} col1={'col-lg-3 col-md-3 col-3 d-lg-none dl-block'}
                col2={'col-lg-2 col-md-4 col-6'}
                col3={'col-lg-7 col-md-1 col-1'}
                col4={'col-lg-3 col-md-4 col-2'} />
            <PageTitle
                pageTitle={"Career"}
                pagesub={"Join the Future of Real Estate"}
            />
            <ScrollTextAnimation />

            <div className="career-page">

                {/* HERO */}
                {/* <section className="hero container">
                    <div className="hero-left">
                        <span className="tag">JOIN OUR ELITE TEAM</span>

                        <h1>
                            Join the Future of <span>Real Estate</span>
                        </h1>

                        <p>
                            Be part of an elite team redefining luxury living through
                            unparalleled expertise, innovation, and a commitment to excellence.
                        </p>

                        <div className="hero-buttons">
                            <button className="primary-btn">Explore Openings</button>
                            <button className="secondary-btn">▶ Watch Our Story</button>
                        </div>
                    </div>

                    <div className="hero-right">
                        <img
                            src="https://lh3.googleusercontent.com/aida-public/AB6AXuDhTaXw8D6mH9WV5jgzuwhvU54xZS6hEBi0WFEucjjrpAFiBEToiMDC6A5kAGfC-rHauBjoQjXXUBo_LbtqamPdJSLsRIhbFXuwVJVeGKgRmMjVJxTFBpNidbiHDMlIUFtARXjrYLmNi_FcUhKLcPZ8CpAKuuocQe17g6mfwcmt3Bu1p32YFeKTLRA9soC4OKsiDqdZU4QTTsmcQrJhRa82EwR-AJLDBuOGrxFfSrR8CIrx6gEgKui3ANzQ2WAbQwnlvRHnMl28gqQ"
                            alt=""
                        />
                    </div>
                </section> */}

                {/* VALUES */}
                <section className="values container">
                    <div className="section-title">
                        <h2>Built on Excellence</h2>
                        <p>
                            Our culture is defined by our core values, driving every decision we
                            make and every relationship we build.
                        </p>
                    </div>

                    <div className="values-grid">
                        <div className="value-card">
                            <h3>Integrity</h3>
                            <p>
                                Unwavering ethical standards in every transaction and client
                                interaction.
                            </p>
                        </div>

                        <div className="value-card">
                            <h3>Innovation</h3>
                            <p>
                                Pioneering new digital solutions and marketing strategies for
                                luxury markets.
                            </p>
                        </div>

                        <div className="value-card">
                            <h3>Excellence</h3>
                            <p>
                                A relentless commitment to quality and attention to the smallest
                                details.
                            </p>
                        </div>

                        <div className="value-card">
                            <h3>Growth</h3>
                            <p>
                                Continuous professional development and mentorship for every team
                                member.
                            </p>
                        </div>
                    </div>
                </section>

                {/* BENEFITS */}
                <section className="benefits container">
                    <div className="benefits-left">
                        <h2>Why Join Luxrock?</h2>
                        <p>
                            We invest in our people just as much as we invest in premium real
                            estate. Experience a career where your ambition is matched by our
                            resources.
                        </p>

                        <div className="quote-box">
                            “The best environment for real estate professionals who want to push
                            boundaries.”
                        </div>
                    </div>

                    <div className="benefits-right">
                        <div className="benefit">
                            <span>01</span>
                            <div>
                                <h4>Professional Growth</h4>
                                <p>Annual learning stipends and leadership training programs.</p>
                            </div>
                        </div>

                        <div className="benefit">
                            <span>02</span>
                            <div>
                                <h4>Competitive Pay</h4>
                                <p>Industry-leading commission splits and bonuses.</p>
                            </div>
                        </div>

                        <div className="benefit">
                            <span>03</span>
                            <div>
                                <h4>Dynamic Environment</h4>
                                <p>Collaborative modern workspaces in prime locations.</p>
                            </div>
                        </div>

                        <div className="benefit">
                            <span>04</span>
                            <div>
                                <h4>Health & Wellness</h4>
                                <p>Comprehensive health insurance and wellness memberships.</p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* JOB LIST */}
                <section className="jobs container">
                    <div className="jobs-header">
                        <div>
                            <h2>Current Openings</h2>
                            <p>Explore our latest career opportunities.</p>
                        </div>

                        {/* <button className="view-all">View All Positions</button> */}
                    </div>

                    {jobs.map((job, i) => (
                        <div className="job-card" key={i}>
                            <div className="job-info">
                                <h3>{job.title}</h3>

                                <div className="job-meta">
                                    <span>{job.location}</span>
                                    <span>{job.type}</span>
                                    <span>{job.salary}</span>
                                </div>
                            </div>

                            <div className="job-actions">
                                <Link to={`/career/${job.id}`} className="primary-btn text-dark">
                                    View Details
                                </Link>
                                {/* <button className="primary-btn" onClick={() => setOpenForm(true)}
                                >Apply Now</button> */}
                            </div>
                        </div>
                    ))}
                </section>

                {/* TESTIMONIAL */}
                {/* <section className="testimonial container">
        <div className="avatar">
          <img src="https://lh3.googleusercontent.com/aida-public/AB6AXuCz7rAXru8X5FWDpscr2ow4o-7B0WHYBJgmemGGAo2HsIDcZIVgk8YfUXAfbwkdSW0PRXF5e6loWKeDXiX2C8PKclMT7GR8Owp3UI5FJE2lra9_X2evXimwvWH5vbefmfQ4ABahprBFCGyp4vpJEfyoVB2Y8QE59AL06FnHpbHHqc7uc-vD-9drAic6Hyr_x7Uaj0qeUyIZiCtc3vy4Sf0Q3Vh17jSd1xaHYjpzqf6JUJgjV6wyLIpru_rObIsTo2Tv1gUHbrp-w9M" alt="images"/>
        </div>

        <div className="testimonial-text">
          <p>
            “Working at Luxrock has been the most transformative experience of
            my career. The resources, the network, and the culture of excellence
            push you to become the best version of yourself.”
          </p>

          <h4>Priya Sharma</h4>
          <span>Head of Consulting</span>
        </div>
      </section> */}

                {/* CTA */}
                <section className="resume container">
                    <h2>Don't see a perfect fit?</h2>

                    <p>
                        We're always looking for talented individuals to join our mission.
                        Send us your resume and tell us how you can contribute to the future
                        of real estate.
                    </p>

                    <button
                        className="apply-btn"
                        onClick={() => setOpenForm(true)}
                    >
                        Submit Your Resume
                    </button>
                    {openForm && (
                        <div className="apply-modal">

                            <div
                                className="modal-overlay"
                                onClick={() => setOpenForm(false)}
                            ></div>

                            <div className="modal-content">

                                <button
                                    className="close-btn"
                                    onClick={() => setOpenForm(false)}
                                >
                                    ✕
                                </button>

                                <ApplyForm jobTitle="" />

                            </div>

                        </div>
                    )}
                </section>
            </div>
            <Footer />
            <Scrollbar />

        </>
    );
}